export default __webpack_public_path__ + "static/media/AWAYAM.a1194952.svg";